<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters class="fill-height">
          <v-col
              cols="12"
              md="6"
              class="dct-auth__brand d-none d-md-flex flex-column justify-space-between pa-12 white--text"
          >
            <div class="d-flex align-center">
              <div class="dct-logo dct-logo--onbrand">DCT</div>
              <span class="ml-3 font-weight-bold" style="font-size: 16px">
                Domain Collector
              </span>
            </div>
            <div style="max-width: 380px">
              <h1
                  class="font-weight-bold mb-4"
                  style="font-size: 28px; line-height: 1.3"
              >
                Collect the metrics for a thousand domains in one run.
              </h1>
              <p
                  class="mb-0"
                  style="color: rgba(255, 255, 255, 0.82); font-size: 14px; line-height: 1.6"
              >
                Positions, traffic, keywords, backlinks and topics — one task,
                one export. Save your setup as a preset and reuse it.
              </p>
            </div>
            <div style="color: rgba(255, 255, 255, 0.6); font-size: 12px">
              SerpInsider · internal tool
            </div>
          </v-col>

          <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-center pa-6"
          >
            <div style="width: 100%; max-width: 360px">
              <h2 class="font-weight-bold mb-1" style="font-size: 22px">
                Sign in
              </h2>
              <p class="mb-6" style="opacity: 0.6; font-size: 13px">
                Use your SerpInsider account.
              </p>

              <v-form>
                <div class="text-body-2 font-weight-medium mb-1">Email</div>
                <v-text-field
                    outlined
                    dense
                    name="login"
                    v-model="email"
                    :rules="emailRules"
                    prepend-inner-icon="mdi-email-outline"
                    type="text"
                    hide-details="auto"
                    class="mb-4"
                ></v-text-field>

                <div class="text-body-2 font-weight-medium mb-1">Password</div>
                <v-text-field
                    outlined
                    dense
                    id="password"
                    name="password"
                    :type="show3 ? 'text' : 'password'"
                    :rules="passwordRules"
                    :append-icon="show3 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                    v-model="password"
                    prepend-inner-icon="mdi-lock-outline"
                    hide-details="auto"
                    @click:append="show3 = !show3"
                ></v-text-field>

                <v-alert
                    text
                    dense
                    dismissible
                    border="left"
                    type="error"
                    v-if="error_message"
                    class="mt-4 mb-0"
                >
                  {{ error_message }}
                </v-alert>

                <v-btn
                    color="primary"
                    block
                    large
                    elevation="0"
                    class="mt-6"
                    @click="login"
                    :loading="loading"
                >
                  Sign in
                </v-btn>
              </v-form>

              <p class="text-center mt-6 mb-0" style="opacity: 0.7; font-size: 13px">
                No account yet?
                <a href="#" @click.prevent="to_register">Create one</a>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "LoginFormIndex",
  props: {
    source: String,
  },
  data() {
    return {
      error_message: undefined,
      snackbar: false,
      loading: false,
      show3: false,
      email: '',
      password: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required'
      ],
    }
  },
  computed: {
    message() {
      return this.$store.state.auth.response.msg
    }
  },
  methods: {
    to_register() {
      this.$router.push('/register')
    },
    login() {
      let self = this

      self.error_message = undefined

      self.loading = true

      self.$store.dispatch('login', {
        email: self.email,
        password: self.password,
        then() {
          let redirect_url = self.$store.state.redirect_to_after_login;

          if (redirect_url !== '') {
            self.$store.state.redirect_to_after_login = '';
            self.$router.push(redirect_url)
          } else {
            self.$router.push('/')
          }
        },
        catch() {
          self.loading = false
          self.error_message = self.$store.state.auth.response.msg
          self.snackbar = true
        }
      })
    }
  },
}
</script>